import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=57c7a210&scoped=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=57c7a210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c7a210",
  null
  
)

export default component.exports